import type { CampaignClock, Row } from '../ability/context.js';
import { browserDependencies } from './browser-dependencies.js';
import type { E } from './k4-dispatch/support-b2.js';

const units = ['year', 'month', 'day', 'hour', 'minute', 'second'] as const;
/** Calendar comparisons preserve authored zero fields; normalizing dates changes expiry. */
export function clockPortEnvironment(clock: CampaignClock, extra: Partial<E['deps']> = {}): E {
  const deps = {
    campaign_field: (_campaign: unknown, key: string) => clock[key.replace('campaign_time_', '') as keyof CampaignClock] ?? null,
    compare_campaign_times: (...args: unknown[]) => {
      for (let i = 0; i < units.length; i++) {
        const a = Number(args[i] ?? 0), b = Number(args[i + units.length] ?? 0);
        if (a !== b) return a > b;
      }
      return true;
    },
    ...extra,
  };
  return browserDependencies(deps) as unknown as E;
}
/** Existing status readers unwrap numeric slots before calling the scalar K4 port. */
export function statusClockRow(status: Row, scalar: (value: unknown) => unknown): Row {
  return Object.fromEntries(units.flatMap(unit => ['ends', 'paused'].map(kind => {
    const key = `status_${kind}_campaign_${unit}`;
    return [key, scalar(status[key]) ?? 0];
  })));
}
